//////LIBRARY//////
import React, { useEffect, useState, Fragment, useMemo } from 'react'
import styled from 'styled-components'
import { cloneDeep, isEmpty, isUndefined, isEqual, map, isNull, forEach, replace, find } from 'lodash'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import moment from 'moment'
//////COMPONENTS//////
import { uriList } from '../../routings/settings/RouteList'
import { kioskProductionListActionCreators, columnsActionCreators, tableActionCreators } from '../../store/actions'
import Table from '../../components/Table'
import DropdownCheckbox from '../../components/DropdownCheckbox'
import UseCheckAll from '../../hooks/UseCheckAll'
import userPrivileges from '../../constants/PrivilegesList'
import urlExport from '../../constants/UrlExport'
import ActionsTable from '../../components/ActionsTable/ActionsTable'
import KioskProductionListStatus from './Components'
import Modals from '../../components/Modals'
import Theme from '../../theme/theme'
import Button from '../../components/Ui/Buttons'
import { ButtonWrapper, TextModal } from '../../theme/GlobalCss'
import StringFormatter from '../../helpers/StringFormatter'
import TableTitle from '../../components/Table/components/TableTitle'
//////ASSETS//////
import Validation from '../../assets/icones/global/check.svg'

//////STYLED//////
const KioskProductionListWrapper = styled.div`
	position: relative;
`
const TextModalWrapper = styled.div`
	width: 100%;
	height: auto;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
`
const TextModalBatteryList = styled.p`
	& > * {
		display: block;
	}
	& > div {
		display: grid;
		grid-column-gap: 10px;
		vertical-align: middle;
		grid-template-columns: auto auto;
	}
`
const TextModalWsList = styled.p`
	& > * {
		display: block;
	}
	& > div {
		display: grid;
		grid-column-gap: 10px;
		vertical-align: middle;
		grid-template-columns: auto auto;
	}
`
const ButtonWrapperCustom = styled(ButtonWrapper)`
	justify-content: center;
`
const TextModalStatusBatteryWrapper = styled.div`
	display: flex;
	flex-direction: row;
`
const TextModalStatusBattery = styled.div`
	width: 20px;
	height: 20px;
	background-color: ${(props) => {
		switch (props.level) {
			case 1:
				return props.theme.colors.validation

			case 2:
				return props.theme.colors.warning

			case 3:
				return props.theme.colors.error

			default:
				return props.theme.colors.cancel
		}
	}};
	border-radius: 10px;
	margin: auto;
`
//////STYLED//////

const KioskProductionList = () => {
	const {
		user,
		translations,
		userKioskPerimeter,
		kioskProductionList,
		userRolePrivileges,
		initKioskCustomerFilters,
		isSearchfieldUpdated,
		currentColumn,
		currentDir,
	} = useSelector(
		(state) => ({
			user: state.user,
			translations: state.languages.translations,
			userKioskPerimeter: state.user.identity.kioskSelected,
			kioskProductionList: state.kioskProductionList,
			userRolePrivileges: state.user.identity.rolePrivileges,
			initKioskCustomerFilters: state.kioskProductionList.header,
			isSearchfieldUpdated: state.columns.isSearchfieldUpdated,
			currentColumn: state.columns.currentColumn,
			currentDir: state.columns.currentDir,
		}),
		shallowEqual
	)

	const [swytch, setSwytch] = useState(false)

	const history = useHistory()

	// Modals
	const [row, setRow] = useState()
	const [showModalSimCard, setShowModalSimCard] = useState(true)
	const [showModalBattery, setShowModalBattery] = useState(false)
	const [showModalWS, setShowModalWS] = useState(false)

	// Paging
	const [paging, setPaging] = useState({
		page: '0',
		size: '250',
		sort: 'owner.company.labelToDisplay',
		nameDir: 'asc',
		sort_2: 'labelToManufacturer',
		nameDir_2: 'asc',
	})

	// Search bar
	const [searchValue, setSearchValue] = useState()

	// Filters
	const [prevFilter, setPrevFilter] = useState({})
	const [filters, setFilters, handleCheckElements] = UseCheckAll(prevFilter)

	const [currentPerimeterKiosks, setCurrentPerimeterKiosks] = useState([])

	const actionsKioskProductionList = bindActionCreators(kioskProductionListActionCreators, useDispatch())
	const actionsColumns = bindActionCreators(columnsActionCreators, useDispatch())
	const actionsTable = bindActionCreators(tableActionCreators, useDispatch())

	// Array which will contain translated trad keys, ordered alphabetically based on current user language
	const [currentWsStateOrder, setCurrentWsStateOrder] = useState()

	// Columns
	const [columns, setColumns] = useState([])

	/////////////////////////////// HANDLER //////////////////////////////////////

	const handlePagingKioskProductionList = (paging) => {
		let sortMap = {}
		if (!isUndefined(currentColumn.value)) {
			sortMap = {
				sort: currentColumn.value,
				nameDir: currentDir.value,
			}
		} else {
			sortMap = {
				sort: 'owner.company.labelToDisplay',
				nameDir: 'asc',
				sort_2: 'labelToManufacturer',
				nameDir_2: 'asc',
			}
		}
		const pg = { ...paging, ...sortMap }
		setPaging(pg)
		actionsKioskProductionList.getKioskProductionList(handleFilterSend(), pg)
	}

	// handler search bar
	const handleSearchEnter = (e, val) => {
		if (e.keyCode !== 13) return
		setSearchValue(val)
		actionsColumns.setIsSearchfieldUpdated(true)
	}

	const handleClickSearch = (refInput) => {
		setSearchValue(refInput.current.value)
		actionsColumns.setIsSearchfieldUpdated(true)
	}

	const handleSubmit = () => {
		if (isEqual(filters, prevFilter)) return // guard to call if no change
		setPrevFilter(filters)

		// Force reset paging at zero, in case when filters are preventing any pagination with current size
		let pg = cloneDeep(paging)
		if (isUndefined(pg)) {
			pg = { page: '0', size: '250', sort: 'owner.company.labelToDisplay,asc', nameDir: 'asc', sort_2: 'labelToManufacturer', nameDir_2: 'asc' }
		} else {
			pg.page = '0'
		}
		setPaging(pg)

		actionsKioskProductionList.getKioskProductionList(handleFilterSend(), pg)
	}

	const handleFilterSend = () => {
		const filtersIn = cloneDeep(filters)
		let searchFieldUpdated = {}
		let filtersOut = {}

		if (isSearchfieldUpdated) {
			searchFieldUpdated = {
				searchFieldUpdated: true,
			}
		} else {
			searchFieldUpdated = {
				searchFieldUpdated: false,
			}
		}
		filtersOut = { ...searchFieldUpdated, ...filtersIn }
		return {
			...filtersOut,
			withFilters: true,
			userKioskScope: {
				kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
			},
		}
	}

	const handleOpenModals = (modal, row) => {
		setRow(row)
		switch (modal) {
			case 'handleModalSimCard':
				actionsKioskProductionList.getInfosSimCard(row.id)
				setShowModalSimCard(true)
				break
			case 'handleModalBattery':
				actionsKioskProductionList.getInfosBattery(row.id)
				setShowModalBattery(true)
				break
			case 'handleModalWS':
				actionsKioskProductionList.getInfosWS(row.id)
				setShowModalWS(true)
				break
			default:
				break
		}
	}

	const handleCloseModals = () => {
		if (showModalSimCard) {
			setShowModalSimCard(false)
		}
		if (showModalBattery) {
			setShowModalBattery(false)
		}
		if (showModalWS) {
			setShowModalWS(false)
		}
	}

	const handleSeeKioskLogs = (rowKiosk) => {
		history.push(`${uriList.kiosksInProduction}${uriList.kioskProductionList}${uriList.kioskDiagnostic}/${rowKiosk.id}`)
	}

	const handleSeeKioskRacks = (rowKiosk) => {
		history.push(`${uriList.kiosksInProduction}${uriList.kioskProductionList}${uriList.kioskRacksRequest}/${rowKiosk.id}`)
	}

	const handleSeeKioskImplantation = (rowKiosk) => {
		history.push(`${uriList.kiosksInProduction}${uriList.kioskProductionList}${uriList.kioskEditImplantation}/${rowKiosk.id}`)
	}

	// By current language used, determine alphabetical order of states for WS modal
	const handleWSStateTraductionsOrder = () => {
		let ord = []
		forEach(configWsState, (elem) => {
			ord.push({ translatedKey: translations[elem.tradKey], objName: elem.objName })
		})
		ord.sort((a, b) => a['translatedKey'].localeCompare(b['translatedKey'], undefined, { alphabetic: true }))
		setCurrentWsStateOrder(ord)
	}

	// To redirect on kiosk production detail

	const handleKioskEditSetup = (rowKiosk) => {
		history.push(`${uriList.kiosksInProduction}${uriList.kioskProductionList}${uriList.kioskEditSetUp}/${rowKiosk.id}`)
	}
	/////////////////////////////// CONFIG //////////////////////////////////////

	const [configTableTitle, setConfigTableTitle] = useState({
		actions: {
			searchBarComponent: {
				handleSearchEnter: handleSearchEnter,
				handleClickSearch: handleClickSearch,
				placeholder: translations['common__text__fastFilter_search'],
				handleReset: (refInput) => {
					refInput.current.value = ''
					setSearchValue('')
				},
			},
		},
		paging: { fnSendTo: (paging) => handlePagingKioskProductionList(paging) },
	})
	const [configTable, setConfigTable] = useState({})

	useEffect(() => {
		setColumns([
			/* 		{
						columnReferential: 'kioskInProduction_globalIntegrity',
						dataHook: 'globalIntegrity.label',
						headerName: translations['page__initKiosksProduction__kioskList_tableHeader_generalState'],
						sortable: true,
						isAuthorize: true,
						component: (props) => <KioskProductionListStatus level={props.row?.globalIntegrity.level} />,
						sortableId: 'global.translationKey.id',
					}, */
			{
				columnReferential: 'kioskInProduction_kioskCode',
				dataHook: 'kioskCode',
				headerName: translations['page__initKiosksProduction__kioskList_tableHeader_kioskCode'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'labelToManufacturer',
			},
			{
				columnReferential: 'kioskInProduction_clientKioskCode',
				dataHook: 'customerKioskCode',
				headerName: translations['page__initKiosksProduction__kioskList_tableHeader_customerKioskCode'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'labelToOwner',
			},
			{
				columnReferential: 'kioskInProduction_kioskName',
				dataHook: 'kioskName',
				headerName: translations['page__initKiosksProduction__kioskList_tableHeader_kioskName'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'description',
			},
			{
				columnReferential: 'kioskInProduction_owner',
				dataHook: 'owner',
				headerName: translations['page__initKiosksProduction__kioskList_tableHeader_owner'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'owner.company.labelToDisplay',
			},

			{
				columnReferential: 'kioskInProduction_techSupport',
				dataHook: 'maintainer',
				headerName: translations['page__initKiosksProduction__kioskList_tableHeader_maintainer'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'company.labelToDisplay',
			},
			/* {
				columnReferential: 'kioskInProduction_bankFlowIntegrity',
				dataHook: 'bankFlowIntegrity.label',
				headerName: translations['page__initKiosksProduction__kioskList_tableHeader_bankState'],
				sortable: true,
				isAuthorize: true,
				component: (props) => (
					<KioskProductionListStatus
						level={
							!isUndefined(props.row?.bankFlowIntegrity) && !isNull(props.row?.bankFlowIntegrity)
								? props.row?.bankFlowIntegrity.level
								: ''
						}
						tooltip={props.row?.bankFlowIntegrity.translationKey}
						tooltipId={`${props.row.id}_bankFlowIntegrity_${props.row?.bankFlowIntegrity.level}`}
					/>
				),
				sortableId: 'bankFlowInt.translationKey.id',
			},
			{
				columnReferential: 'kioskInProduction_printerIntegrity',
				dataHook: 'printerIntegrity.label',
				headerName: translations['page__initKiosksProduction__kioskList_tableHeader_printState'],
				sortable: true,
				isAuthorize: true,
				component: (props) => (
					<KioskProductionListStatus
						level={
							!isUndefined(props.row?.printerIntegrity) && !isNull(props.row?.printerIntegrity) ? props.row?.printerIntegrity.level : ''
						}
						tooltip={props.row?.printerIntegrity.translationKey}
						tooltipId={`${props.row.id}_printerIntegrity_${props.row?.printerIntegrity.level}`}
					/>
				),
				sortableId: 'printerInt.translationKey.id',
			},
			{
				columnReferential: 'kioskInProduction_simCardIntegrity',
				dataHook: 'simCardIntegrity.label',
				headerName: translations['page__initKiosksProduction__kioskList_tableHeader_simCardState'],
				sortable: true,
				isAuthorize: true,
				component: (props) => (
					<KioskProductionListStatus
						level={
							!isUndefined(props.row.simCardIntegrity) && !isNull(props.row.simCardIntegrity) ? props.row.simCardIntegrity.level : ''
						}
						tooltip={props.row?.simCardIntegrity.translationKey}
						tooltipId={`${props.row.id}_simCardIntegrity_${props.row?.simCardIntegrity.level}`}
						handleClick={() => handleOpenModals('handleModalSimCard', props.row)}
					/>
				),
				sortableId: 'simCardInt.translationKey.id',
			},
			{
				columnReferential: 'kioskInProduction_batteryIntegrity',
				dataHook: 'batteryIntegrity.label',
				headerName: translations['page__initKiosksProduction__kioskList_tableHeader_batteryState'],
				sortable: true,
				isAuthorize: true,
				component: (props) => (
					<KioskProductionListStatus
						level={
							!isUndefined(props.row.batteryIntegrity) && !isNull(props.row.batteryIntegrity) ? props.row.batteryIntegrity.level : ''
						}
						tooltip={props.row?.batteryIntegrity.translationKey}
						tooltipId={`${props.row.id}_batteryIntegrity_${props.row?.batteryIntegrity.level}`}
						handleClick={() => handleOpenModals('handleModalBattery', props.row)}
					/>
				),
				sortableId: 'battery.translationKey.id',
			},
			{
				columnReferential: 'kioskInProduction_webServiceIntegrity',
				dataHook: 'wsIntegrity.label',
				headerName: translations['page__initKiosksProduction__kioskList_tableHeader_WSState'],
				sortable: true,
				isAuthorize: true,
				component: (props) => (
					<KioskProductionListStatus
						level={!isUndefined(props.row?.wsIntegrity) && !isNull(props.row?.wsIntegrity) ? props.row?.wsIntegrity.level : ''}
						tooltip={props.row?.wsIntegrity.translationKey}
						tooltipId={`${props.row.id}_wsIntegrity_${props.row?.wsIntegrity.level}`}
						handleClick={() => handleOpenModals('handleModalWS', props.row)}
					/>
				),
				sortableId: 'wsInt.translationKey.id',
			}, */
			/* 		{
						columnReferential: 'kioskInProduction_webServiceCommunication',
						dataHook: 'wsCommunication',
						headerName: translations['page__initKiosksProduction__kioskList_tableHeader_COMState'],
						sortable: true,
						isAuthorize: true,
						component: (props) => (
							<KioskProductionListStatus
								level={
									!isUndefined(props.row?.wsCommunication) && !isNull(props.row?.wsCommunication) ? props.row?.wsCommunication.level : ''
								}
								tooltip={props.row?.wsCommunication.translationKey}
								tooltipId={`${props.row.id}wsCommunication${props.row?.wsCommunication.level}`}
							/>
						),
						sortableId: 'wsComInt.label',
					}, */
			{
				columnReferential: 'kioskInProduction_dateAutodiage',
				dataHook: 'autoDiag',
				headerName: translations['page__initKiosksProduction__kioskList_tableHeader_autoDiagDate'],
				sortable: true,
				isAuthorize: true,
				component: (props) => (!isNull(props.row.autoDiag) ? moment(props.row.autoDiag).format('DD/MM/YYYY HH:mm') : '-'),
				sortableId: 'autoDiag.lastAutoDiagDate',
			},
			{
				columnReferential: 'kioskInProduction_displayStandNumber',
				dataHook: 'racksNumber',
				headerName: translations['page__initKiosksProduction__kioskList_tableHeader_rackNumber'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'racksNumber',
			},

			{
				columnReferential: 'kioskInProduction_lockerNumber',
				dataHook: 'lockersNumber',
				headerName: translations['page__initKiosksProduction__kioskList_tableHeader_lockerNumber'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'lockersNumber',
			},

			{
				columnReferential: 'kioskInProduction_kioskModel',
				dataHook: 'kioskModel',
				headerName: translations['page__initKiosksProduction__kioskList_tableHeader_kioskModel'],
				sortable: true,
				isAuthorize: true,
				toTranslate: true,
				sortableId: 'kioskModel.translationKey.id',
			},

			//{dataHook: 'comKiosIntegrity', headerName: translations["page__initKiosksProduction__kioskList_tableHeader_COMState"], sortable: true, isAuthorize: true, component: (props) => <KioskProductionListStatus level={props.row.comKiosIntegrity.level}/>},
			{
				action: true,
				isFixed: true,
				component: ActionsTable,
				withIcons: false,
				rest: {
					tooltipPart: 'kioskProductionList',
					paperActionsList: [
						{
							name: translations['page__initKiosksProduction__kioskList_tableHeader_modalAction_button_kioskLogs'],
							clickAction: (row) => {
								handleSeeKioskLogs(row)
							},
							isVisible: (row) => !isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.view[41])),
							//iconDef: ViewKioskLogs,
							translationKey: 'tooltip__admin__initKiosksProduction__kioskList__kioskLogs',
						},
						{
							//iconDef: editKioskSetup,
							name: translations['page__nitKiosksProduction__kioskList__tableAction_EditKioskConfiguration'],
							translationKey: 'tooltip__admin__global__action__kioskInProductionModify_edit',
							clickAction: (row) => {
								handleKioskEditSetup(row)
							},
							//isVisible: (row) => true,
							isVisible: (row) => !isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.view[38])),
						},
						{
							name: translations['page__admin__rackUpdate_editConfig_action'],
							clickAction: (row) => {
								handleSeeKioskRacks(row)
							},
							isVisible: (row) => !isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.view[39])),
							//isVisible: (row) => true,
							//icon: editRackSetup,
							translationKey: 'page__admin__rackUpdate_editConfig_action',
						},
						{
							name: translations['page__kiosk__in__production__modify__implantation__admin__tab_title'],
							clickAction: (row) => {
								handleSeeKioskImplantation(row)
							},
							isVisible: (row) => !isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.view[40])),
							//isVisible: (row) => true,
							//icon: editKioskImplementation,
							translationKey: 'page__kiosk__in__production__modify__implantation__admin__tab_title',
						},
					],
				},
			},
		])
	}, [translations])

	// Used for columns displaying (redux stored)
	const tableReferential = {
		idPageTable: 22,
		labelPageTable: 'kioskInProduction',
	}

	// Config to associate state WS trad keys with object returned by back call
	const configWsState = [
		{ tradKey: 'page__initKiosksProduction__modal__webServiceInfo__body_articleState', objName: 'itemStatus' },
		{ tradKey: 'page__initKiosksProduction__modal__webServiceInfo__body_implementationState', objName: 'implantationStatus' },
		{ tradKey: 'page__initKiosksProduction__modal__webServiceInfo__body_deliveryState', objName: 'deliveryStatus' },
		{ tradKey: 'page__initKiosksProduction__modal__webServiceInfo__body_logState', objName: 'logStatus' },
		{ tradKey: 'page__initKiosksProduction__modal__webServiceInfo__body_priceState', objName: 'priceStatus' },
		{ tradKey: 'page__initKiosksProduction__modal__webServiceInfo__body_promotionState', objName: 'promoStatus' },
		{ tradKey: 'page__initKiosksProduction__modal__webServiceInfo__body_stock', objName: 'stockStatus' },
		{ tradKey: 'page__initKiosksProduction__modal__webServiceInfo__body_saleState', objName: 'saleStatus' },
		{ tradKey: 'page__initKiosksProduction__modal__webServiceInfo__body_saleCodeState', objName: 'saleCodeStatus' },
		{ tradKey: 'page__initKiosksProduction__modal__webServiceInfo__body_kioskStateState', objName: 'kioskStateStatus' },
		{ tradKey: 'page__initKiosksProduction__modal__webServiceInfo__body_maintainerState', objName: 'maintainerStatus' },
		{ tradKey: 'page__initKiosksProduction__modal__webServiceInfo__body_paymentCollectionState', objName: 'paymentCollectionStatus' },
	]

	/////////////////////////////// USE EFFECT //////////////////////////////////////

	useEffect(() => {
		return function cleanUp() {
			actionsKioskProductionList.resetDataKioskProductionList()
			actionsTable.resetPaggingConfig()
		}
	}, [])

	useEffect(() => {
		let cfg = cloneDeep(configTableTitle)

		cfg.actions.searchBarComponent = {
			handleSearchEnter: handleSearchEnter,
			handleClickSearch: handleClickSearch,
			placeholder: translations['common__text__fastFilter_search'],
			defaultValue: searchValue,
			handleReset: (refInput) => {
				refInput.current.value = ''
				setSearchValue('')
			},
		}
		setConfigTableTitle(cfg)
	}, [searchValue])

	useEffect(() => {
		const filtersCP = cloneDeep(filters)
		filtersCP.searchField = searchValue
		setFilters(filtersCP)
	}, [searchValue])

	useEffect(() => {
		if (filters.searchField !== searchValue || searchValue === kioskProductionList.labelToDisplay) return
		handleSubmit()
	}, [filters.searchField])

	useEffect(() => {
		setFilters(initKioskCustomerFilters)
		setPrevFilter(initKioskCustomerFilters)
	}, [translations, initKioskCustomerFilters])

	useEffect(() => {
		let cfg = cloneDeep(configTableTitle)

		cfg.name = translations['page__initKiosksProduction__kioskList_title']

		cfg.paging = {
			totalElements: kioskProductionList.paging.totalElements,
			totalPages: kioskProductionList.paging.totalPages,
			fnSendTo: (paging) => handlePagingKioskProductionList(paging),
		}

		cfg.actions.rest = [
			() => (
				<DropdownCheckbox
					title={translations['page__initKiosksProduction__kioskList_filters_maintainer']}
					data={filters.filtersSelection?.maintainers.filterElements || []}
					translations={translations}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'maintainers'}
				/>
			),

			() => (
				<DropdownCheckbox
					title={translations['page__initKiosksProduction__kioskList_filters_owner']}
					data={filters.filtersSelection?.owners.filterElements || []}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'owners'}
				/>
			),
		]

		cfg.actions.searchBarComponent = {
			handleSearchEnter: handleSearchEnter,
			handleClickSearch: handleClickSearch,
			placeholder: translations['common__text__fastFilter_search'],
			defaultValue: searchValue,
			handleReset: (refInput) => {
				refInput.current.value = ''
				setSearchValue('')
			},
		}
		setConfigTableTitle(cfg)
	}, [filters, translations])

	useEffect(() => {
		const cfgCp = cloneDeep(configTable)
		cfgCp.export = {
			privilege: userPrivileges.export[20],
			url: urlExport[18],
			bd: {
				filtersSelection: filters.filtersSelection,
				searchField: searchValue,
				withFilters: true,
				userKioskScope: {
					kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
				},
			},
		}
		setConfigTable(cfgCp)
	}, [translations, filters])

	useEffect(() => {
		if (!isUndefined(user) || !isEmpty(searchValue)) {
			setSwytch(true)
		}
	}, [user, searchValue])

	useEffect(() => {
		if (isUndefined(user)) return
		if (swytch) {
			if (!isNull(kioskProductionList.labelToDisplay)) setFilters({ searchField: kioskProductionList.labelToDisplay })
			const filtersCp = {
				withFilters: false,
				filtersSelection: null,
				searchField: filters.searchField,
				userKioskScope: {
					kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
				},
				searchFieldUpdated: searchValue?.length > 0 ? true : false,
			}
			actionsKioskProductionList.getKioskProductionList(filtersCp)
			actionsColumns.setColumns([])

			setFilters(filtersCp)
		}
	}, [swytch, translations])

	useEffect(() => {
		// If we came from redirection
		let filtersCP = cloneDeep(filters)
		if (!isNull(kioskProductionList.labelToDisplay)) {
			setSearchValue(kioskProductionList.labelToDisplay)
			filtersCP.searchField = kioskProductionList.labelToDisplay
		}
		setFilters(filtersCP)
	}, [kioskProductionList.labelToDisplay])

	// If user is changing his perimeter, we need to make a back call
	useEffect(() => {
		if (!isEqual(userKioskPerimeter, currentPerimeterKiosks) && !isEmpty(currentPerimeterKiosks))
			actionsKioskProductionList.getKioskProductionList(handleFilterSend(), paging)
		setCurrentPerimeterKiosks(userKioskPerimeter)
	}, [userKioskPerimeter])

	useEffect(() => {
		const cfg = cloneDeep(configTableTitle)
		if (!isEmpty(kioskProductionList) && !isUndefined(kioskProductionList)) {
			cfg.paging = {
				totalElements: kioskProductionList.paging.totalElements,
				totalPages: kioskProductionList.paging.totalPages,
				fnSendTo: (paging) => handlePagingKioskProductionList(paging),
			}
			setConfigTableTitle(cfg)
		}
	}, [kioskProductionList])

	// Will be used for WS modal
	// We need alphabetical order based on translations (so on current language)
	// Everytime translations change, this need to be calculated
	useEffect(() => {
		if (!isEqual(translations, {})) handleWSStateTraductionsOrder()
	}, [translations])

	// use to set message  and add a break line on text modal
	const [text, setText] = useState('')
	const [textIsp, setSetTextIsp] = useState('')
	const [textRssi, setSetTextRssi] = useState('')

	useEffect(() => {
		if (!isNull(kioskProductionList.modalInfo.simCard)) {
			if (isNull(kioskProductionList.modalInfo.simCard.isp)) {
				setSetTextIsp(translations['page__global__admin__undefineData'])
			} else {
				setSetTextIsp(kioskProductionList.modalInfo.simCard.isp)
			}
			if (isNull(kioskProductionList.modalInfo.simCard.rssi)) {
				setSetTextRssi(translations['page__global__admin__undefineData'])
			} else {
				setSetTextRssi(kioskProductionList.modalInfo.simCard.rssi)
			}
		}
	}, [kioskProductionList.modalInfo.simCard, kioskProductionList.modalInfo.simCard])

	useEffect(() => {
		setText(
			StringFormatter.ResponseMessageParser(replace(translations['page__initKiosksProduction__modal__simCardInfo__body'], '\\n', '<br>'), [
				textIsp,
				textRssi,
			])
		)
	}, [textIsp, textRssi])

	///////////////////////////////// RENDER ///////////////////////////////////////
	const TableRender = useMemo(() => {
		return (
			<Table
				inputColumns={columns}
				inputData={kioskProductionList.items}
				inputConfig={configTable}
				currentPaging={paging}
				isLoading={kioskProductionList.isLoading}
				tableReferential={tableReferential}
				actionSort={actionsKioskProductionList.getKioskProductionList}
			/>
		)
	}, [kioskProductionList, columns, configTable, translations, paging])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<Fragment>
			{!isNull(kioskProductionList.modalInfo.simCard) && (
				<Modals
					title={`${translations['page__initKiosksProduction__modal__simCardInfo__title']} - ${row?.kioskCode}`}
					icon={true}
					showModal={showModalSimCard}
					closeModalHandler={handleCloseModals}
				>
					<TextModalWrapper>
						<TextModal dangerouslySetInnerHTML={{ __html: text }}></TextModal>
					</TextModalWrapper>
					<ButtonWrapperCustom>
						<Button
							actionHandler={handleCloseModals}
							text={translations['common__text__validate']}
							bgColor={Theme.colors.validation}
							img={Validation}
						/>
					</ButtonWrapperCustom>
				</Modals>
			)}
			{!isNull(kioskProductionList.modalInfo.battery) && (
				<Modals
					title={`${translations['page__initKiosksProduction__modal__batteryInfo__title']} - ${row?.kioskCode}`}
					icon={true}
					showModal={showModalBattery}
					closeModalHandler={handleCloseModals}
				>
					<TextModalWrapper>
						<TextModal>{translations['page__initKiosksProduction__modal__batteryInfo__body']} :</TextModal>
						{/* 					<TextModal>{translations['page__initKiosksProduction__modal__batteryInfo__body_kioskState']} : {translations[kioskProductionList.modalInfo.battery.kioskBattery.translationKey]}</TextModal>
						 */}
						<TextModalStatusBatteryWrapper>
							{/* <TextModal>{translations['page__initKiosksProduction__modal__batteryInfo__body_kioskState']} :</TextModal>
						<TextModalStatusBattery level={kioskProductionList.modalInfo.battery.kioskBattery.level} ></TextModalStatusBattery> */}
							<span style={{ marginRight: '5px' }}>
								{translations['page__initKiosksProduction__modal__batteryInfo__body_kioskState']} :{' '}
							</span>
							<KioskProductionListStatus level={kioskProductionList.modalInfo.battery.kioskBattery.level} />
						</TextModalStatusBatteryWrapper>
						<TextModal>
							<TextModalBatteryList>
								{/* Choose this option if color indications are wanted */}
								<div>
									{map(kioskProductionList.modalInfo.battery.displayStandInfoDtoList, (rack) => {
										return (
											<>
												<span>
													{translations['page__initKiosksProduction__modal__batteryInfo__body_displayStandState']}{' '}
													{rack.displayStandName} :
												</span>
												<KioskProductionListStatus
													level={rack.displayStandBatteryInfo.level}
													tooltip={rack.displayStandBatteryInfo.translationKey}
													tooltipId={rack.displayStandName}
												/>
											</>
										)
									})}
								</div>
								{/* Choose this option if text is wanted */}
								{/*map(kioskProductionList.modalInfo.battery.displayStandInfoDtoList, rack => {
								return (
									<span>{translations['page__initKiosksProduction__modal__batteryInfo__body_displayStandState']} {rack.displayStandName} : {translations[rack.displayStandBatteryInfo.translationKey]}</span>
								)
							})*/}
							</TextModalBatteryList>
						</TextModal>
					</TextModalWrapper>
					<ButtonWrapperCustom>
						<Button
							actionHandler={handleCloseModals}
							text={translations['common__text__validate']}
							bgColor={Theme.colors.validation}
							img={Validation}
						/>
					</ButtonWrapperCustom>
				</Modals>
			)}
			{!isNull(kioskProductionList.modalInfo.ws) && (
				<Modals
					title={`${translations['page__initKiosksProduction__modal__webServiceInfo__title']} - ${row?.kioskCode}`}
					icon={true}
					showModal={showModalWS}
					closeModalHandler={handleCloseModals}
				>
					<TextModalWrapper>
						<TextModal>{translations['page__initKiosksProduction__modal__webServiceInfo__body']} :</TextModal>
						<TextModal>
							{translations['page__initKiosksProduction__modal__webServiceInfo__body_lastDiagDate']} :{' '}
							{moment(kioskProductionList.modalInfo.ws.lastDateDiag).format('DD/MM/YYYY HH:mm')}
						</TextModal>
						<TextModal>
							<TextModalWsList>
								{/* Choose this option if color indications are wanted */}
								<div>
									{map(currentWsStateOrder, (wsInfo) => {
										return (
											<>
												<span>{wsInfo.translatedKey} :</span>
												<KioskProductionListStatus
													level={kioskProductionList.modalInfo.ws[wsInfo.objName]?.level}
													tooltip={kioskProductionList.modalInfo.ws[wsInfo.objName]?.translationKey}
													tooltipId={wsInfo.objName}
												/>
											</>
										)
									})}
								</div>
								{/* Choose this option if text is wanted */}
								{/*map(currentWsStateOrder, wsInfo => {
								return (
									<span>{wsInfo.translatedKey} : {translations[kioskProductionList.modalInfo.ws[wsInfo.objName].translationKey]}</span>
								)
							})*/}
							</TextModalWsList>
						</TextModal>
					</TextModalWrapper>
					<ButtonWrapperCustom>
						<Button
							actionHandler={handleCloseModals}
							text={translations['common__text__validate']}
							bgColor={Theme.colors.validation}
							img={Validation}
						/>
					</ButtonWrapperCustom>
				</Modals>
			)}
			<KioskProductionListWrapper>
				{!isUndefined(translations) && !isUndefined(configTableTitle) && (
					<TableTitle inputConfig={configTableTitle} inputColumns={columns} tableReferential={tableReferential} />
				)}
				{!isUndefined(translations) && !isUndefined(configTable) && TableRender}
			</KioskProductionListWrapper>
		</Fragment>
	)
}

KioskProductionList.propTypes = {}

KioskProductionList.defaultPropTypes = {}

export default KioskProductionList
